<template>
  <v-row justify="center">
    <v-col cols="12" class="pt-16">
      <v-container>
        <back-button @click.native="$router.go(-1)"></back-button>
        <v-row>
          <v-col cols="12" lg="6">
            <h3 class="mb-8 home-header-3">
              Are you a resident of Great Britain currently residing in NI or RoI?
            </h3>
            <v-radio-group
              v-model="ifResidentGBR"
              v-on:change="onRadioGroupClicked"
              class="mb-4"
            >
              <v-radio
                v-on:keyup.enter="ifResidentGBR = 'Yes'; onRadioGroupClicked()"
                label="Yes"
                value="Yes"
                color="#006078"
                class="ml-4 px-8 py-4 black--text"
                :ripple="false"
              ></v-radio>
              <v-radio
                v-on:keyup.enter="ifResidentGBR = 'No'; onRadioGroupClicked()"
                label="No"
                value="No"
                color="#006078"
                class="ml-4 px-8 py-4 black--text"
                :ripple="false"
              ></v-radio>
            </v-radio-group>
            <v-btn
              @click="onAfterContinueClicked"
              class="v-btn--primary"
              :disabled="!ifResidentGBR"
            >
              Continue
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue';
import BackButton from '@/components/BackButton';

export default Vue.extend({
  components: {
    BackButton
  },
  name: 'StepResident',
  data: () => ({
    ifResidentGBR: null
  }),
  methods: {
    onRadioGroupClicked() {
      this.$emit('selected', this.ifResidentGBR);
    },
    onAfterContinueClicked() {
      this.$gtag.event('GBR resident question answered', {})
      if (this.ifResidentGBR === 'Yes') {
        this.$router.push('/booking/not-eligible-resident').catch(() => {});
      } else if (this.ifResidentGBR === 'No') {
        this.$router.push('/booking/resident-roi').catch(() => {});
      }
    }
  }
});
</script>
